export const defaultEpiPropsModel = Object.freeze({
    filterHeaderText: '',
    filterResetText: '',
    nameAndEmailFormTitle: '',
    nameInputLabel: '',
    namePlaceholder: '',
    emailInputLabel: '',
    emailPlaceholder: '',
    nameRequiredError: '',
    emailRequiredError: '',
    emailInvalidError: '',
    submitCtaText: '',
    noResultsMessage: '',
});

